import * as React from 'react';
import { classNames } from '@wix/answers-lib';
import { ArticleViewer } from '../../components-viewer.comp';
import { Icon } from '../../icon/icon';
import favouriteIcon from './favourite-icn.svg';
export const TOTAL_CELL_PADDING = 50;
const removeEmptyHTMLTags = (content) => content.replace(/(<([^>]+)>)/gi, '');
const isEmptyContent = (components) => !components.length ||
    components.filter(component => (component.type === 'text') &&
        removeEmptyHTMLTags(component.value.html).length === 0).length === components.length;
export class TabsComponent extends React.Component {
    constructor() {
        super(...arguments);
        this.recommendedTab = this.props.value.recommendedTab;
        this.findSelectedSlugIndex = (slugs) => this.props.value.slugs.findIndex(slug => slugs.includes(slug));
        this.maybeGetSelectedTabOnLoad = () => {
            const slugs = this.props.selectedTabsOnLoad;
            if (slugs) {
                const selectedIndex = this.findSelectedSlugIndex(slugs);
                return selectedIndex > -1 ? selectedIndex : null;
            }
            return null;
        };
        // Ragged tabs (fewer contents than headings) or an out-of-range recommendedTab read as empty (CCR-17113).
        this.isEmpty = (heading, contents) => !heading || isEmptyContent(contents || []);
        this.isRecommendedNotEmpty = this.recommendedTab !== undefined &&
            !this.isEmpty(this.props.value.headings[this.recommendedTab], this.props.value.contents[this.recommendedTab]);
        this.nonEmptyTabsIdxs = this.props.value.headings.map((heading, idx) => {
            if (!this.isEmpty(heading, this.props.value.contents[idx])) {
                return idx;
            }
            return undefined;
        }).filter(x => x !== undefined);
        this.state = { selectedTab: this.isRecommendedNotEmpty ? this.recommendedTab : this.nonEmptyTabsIdxs[0] };
        this.onHeaderClick = (selectedTab) => {
            this.setState({ selectedTab });
            if (this.props.onTabClick) {
                this.props.onTabClick(selectedTab, this.props.value.slugs || []);
            }
        };
        this.onHeaderKeyDown = (selectedTab) => (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.onHeaderClick(selectedTab);
            }
        };
    }
    componentDidMount() {
        const maybeSelectedTabOnLoad = this.maybeGetSelectedTabOnLoad();
        if (maybeSelectedTabOnLoad !== null) {
            this.setState({ selectedTab: maybeSelectedTabOnLoad });
        }
    }
    render() {
        const props = this.props;
        const { headings, contents } = props.value;
        const headingComps = headings.map((heading, idx) => {
            if (this.isEmpty(heading, contents[idx])) {
                return null;
            }
            const isTabSelected = this.state.selectedTab === idx;
            const isTabRecommneded = props.value.recommendedTab === idx;
            const className = classNames('tab-heading', `heading-${idx}`, { selected: isTabSelected }, { recommended: isTabRecommneded });
            const onHeaderClick = () => this.onHeaderClick(idx);
            return (React.createElement("div", { key: idx, className: className, onClick: onHeaderClick, onKeyDown: this.onHeaderKeyDown(idx), tabIndex: 0, role: 'tab', "aria-selected": isTabSelected },
                React.createElement("div", { className: 'heading-ellipsis' }, heading),
                isTabRecommneded ? React.createElement(Icon, { dangerouslyDisableSanitation: true, className: 'recommended-tab-icon', icon: favouriteIcon }) : null));
        });
        const tabsHeadingsLTR = () => (React.createElement("div", { className: 'tab-headings', role: 'tablist' },
            headingComps,
            React.createElement("div", { className: 'filler-heading' })));
        const tabsHeadingsRTL = () => {
            const reversedHeadings = headingComps && [...headingComps].reverse();
            return (React.createElement("div", { className: 'tab-headings', role: 'tablist' },
                React.createElement("div", { className: 'filler-heading' }),
                reversedHeadings));
        };
        const selectedTab = this.state.selectedTab || 0;
        const tabsContents = (React.createElement("div", { className: 'tab-contents', role: 'tabpanel' },
            React.createElement(ArticleViewer, { components: contents[selectedTab] || [], locale: props.locale })));
        const hasThreeOrLessTabs = this.nonEmptyTabsIdxs.length <= 3;
        return (React.createElement("div", { className: classNames('component', 'tabs-component', this.props.direction, { 'wide-tabs': hasThreeOrLessTabs }), "data-component-type": 'tabs' },
            React.createElement("div", { className: "tabs-wrapper" },
                React.createElement("div", { className: "tabs-inner" },
                    this.props.direction === 'rtl' ? tabsHeadingsRTL() : tabsHeadingsLTR(),
                    tabsContents))));
    }
}
